import React, { useState } from "react";
import "./PGAResearchCenterPage.css";
import SelectPGAEvent from "../LiveTournamentToolPage/SelectPGAEvent";
import FieldOverview from "./FieldOverview";
import Tab from "../../../../Tabs/Tab";
import Tabs from "../../../../Tabs";
import PuttingSplits from "./PuttingSplits";
import CourseHistory from "./CourseHistory";

export default function PGAResearchCenterPage() {
  const [selectedEventId, setSelectedEventId] = useState(undefined);

  return (
    <div className="pga-live-tournament-tool-page-container">
      <div className="pga-live-tournament-tool-filters">
        <React.Suspense fallback={<p>Loading filters...</p>}>
          <div className="pga-live-tournament-tool-filters-event-select">
            <SelectPGAEvent
              setSelectedEventID={setSelectedEventId}
              loadResearchOptions={true}
            />
          </div>
        </React.Suspense>
      </div>
      <div style={{ width: "100%" }}>
        {selectedEventId ? (
          <Tabs>
            <React.Suspense fallback={""} label={"Field Overview"}>
              <FieldOverview eventId={selectedEventId} />
            </React.Suspense>
            <React.Suspense fallback={""} label={"Course History"}>
              <CourseHistory eventId={selectedEventId} />
            </React.Suspense>
            <React.Suspense fallback={""} label={"Putting Splits"}>
              <PuttingSplits eventId={selectedEventId} />
            </React.Suspense>
          </Tabs>
        ) : null}
      </div>
    </div>
  );
}
